import { MoreDrawer } from '@src/pages/AutoInsights/AlertInsights/Insights';
import useDrawerState from '@src/pages/AutoInsights/Hooks/useDrawerState';
import React from 'react';
import Bulb from '@src/icons/insights/bulb.svg';
import { ALERT_INSIGHTS } from '@src/utils/sensor/track';
import { IconWrap, StyledTag } from './styled';
import { Button } from 'antd';
import useAiAlertStore from '@src/globalStore/aiAlertStore';

const AutoInsights = () => {
  const { visible, openDrawer, closeDrawer } = useDrawerState({ trackKey: ALERT_INSIGHTS as any });

  const { filter, setFilter } = useAiAlertStore((state) => ({
    filter: state.autoInsightsFilter,
    setFilter: state.setAutoInsightsFilter,
  }));

  const onClose = () => {
    setFilter({ name: null, alertIds: [] });
  };

  return (
    <div>
      {filter.name && filter.alertIds ? (
        <StyledTag closable onClose={onClose} color="blue">
          <IconWrap>
            <Bulb />
          </IconWrap>
          {filter.name}
        </StyledTag>
      ) : (
        <Button
          onClick={openDrawer}
          icon={
            <IconWrap>
              <Bulb />
            </IconWrap>
          }
        >
          Insights
        </Button>
      )}
      <MoreDrawer visible={visible} closeMore={closeDrawer} />
    </div>
  );
};

export default AutoInsights;
